import { useAxiosInterceptors } from "../../config/axios";
import { AxiosInstance } from "axios";


export class BaseModuleSharedApi {
  basePath = '';
  axiosInstance: AxiosInstance | undefined;

  constructor() {
    this.axiosInstance = useAxiosInterceptors();
  }

  async getList(offset: number, limit: number, headers: any, filters: any, orderby: any, configOptions?: any, params?: any,) {
    const response = await this.axiosInstance!.get(`${this.basePath}`, { params: { offset, limit, ...orderby, ...filters, ...params }, headers, ...configOptions });
    if (response.status === 200) {
      return response.data;
    }
  };

  async get(rowId: number, headers: any, configOptions?: any) {
    const response = await this.axiosInstance!.get(`${this.basePath}/${rowId}`, { headers, ...configOptions });
    if (response.status === 200) {
      return response.data;
    }
  };

  async update(rowId: number, data: any, headers: any, configOptions?: any) {
    const response = await this.axiosInstance!.put(`${this.basePath}/${rowId}`, data, { headers, ...configOptions });
    return response.status === 200;
  };

  async create(data: any, headers: any, configOptions?: any) {
    const response = await this.axiosInstance!.post(`${this.basePath}`, data, { headers, ...configOptions });
    if (response.status === 201) {
      return response.data;
    }
  };

  async duplicate(rowId: any, headers: any, configOptions?: any) {
    const response = await this.axiosInstance!.post(`${this.basePath}/${rowId}`, {}, { headers, ...configOptions });
    if (response.status === 201) {
      return response.data;
    }
  };

  async delete(rowId: number, headers: any, configOptions?: any) {
    const response = await this.axiosInstance!.delete(`${this.basePath}/${rowId}`, { headers, ...configOptions });
    if (response.status === 200) {
      return response.data;
    }
  };

  async deleteBulk(rowIds: number[], headers: any, configOptions?: any) {
    const response = await this.axiosInstance!.delete(`${this.basePath}`, { data: { ids: rowIds }, headers, ...configOptions });
    if (response.status === 200) {
      return response.data;
    }
  };
};
